import { stackName } from '@zorro/environment';

/**
 * Every bucket lives in this region, and the browser needs the host to build a
 * carrier-logo URL — so it cannot come from ZORRO_AWS_REGION, which is not a
 * NEXT_PUBLIC_ variable and is therefore absent from the client bundle.
 */
const S3_REGION = 'us-east-1';

export const EMPLOYER_IMAGES_BUCKET = `zorro-employer-images-${stackName()}`;
export const BENEFIT_DOCUMENTS_BUCKET = `zorro-benefit-documents-${stackName()}`;
export const EMPLOYER_DOCUMENTS_BUCKET = `zorro-employer-documents-${stackName()}`;
export const GENERATED_PDF_BUCKET = `zorro-pdf-templates-${stackName()}`;
export const ALLOWANCE_MODEL_SNAPSHOTS_BUCKET = `zorro-allowance-model-snapshots-${stackName()}`;
export const CARRIER_LOGOS_BUCKET = `zorro-carrier-logos-${stackName()}`;

/**
 * Carrier logos are the one family read straight from the bucket by the
 * browser, unsigned — the bucket grants anonymous `s3:GetObject` — so the base
 * URL itself is part of the contract rather than just the bucket name.
 */
export const CARRIER_LOGOS_BASE_URL = `https://${CARRIER_LOGOS_BUCKET}.s3.${S3_REGION}.amazonaws.com`;

export const BUCKET_EXPIRY = 60;
